<template>
    <v-sheet class="ma-4">
        <h1>Personvernsregler for Visuado AS</h1>
        <br />
        <p>
            På Visuado , tilgjengelig fra www.visuado.com, er personvernet til våre besøkende en av
            våre viktigste prioriteringer. Dette personverndokumentet inneholder typer informasjon
            som samles inn og registreres av Visuado og hvordan vi bruker den.
        </p>

        <p>
            Hvis du har flere spørsmål eller trenger mer informasjon om personvernreglene våre, ikke
            nøl med å kontakte oss.
        </p>

        <p>
            Denne personvernerklæringen gjelder bare for våre online aktiviteter og er gyldig for
            besøkende på nettstedet vårt med hensyn til informasjonen de delte og / eller samler inn
            i Visuado . Denne policyen gjelder ikke informasjon som samles offline eller via andre
            kanaler enn dette nettstedet.
        </p>

        <h2>Vilkår</h2>

        <p>
            Ved å bruke nettstedet vårt, samtykker du herved til våre regler for personvern og
            godtar vilkårene.
        </p>

        <h2>Informasjon vi samler inn</h2>

        <p>
            Personopplysningene du blir bedt om å oppgi, og årsakene til at du blir bedt om å oppgi
            de, vil bli tydeliggjort for deg i det vi ber deg om å oppgi denne informasjonen.
        </p>
        <p>
            Hvis du kontakter oss direkte, kan det hende vi mottar ytterligere informasjon om deg,
            for eksempel navn, e-postadresse, telefonnummer, innholdet i meldingen, eventuelle
            vedlegg du velger å sende oss, og all annen informasjon du velger å oppgi.
        </p>
        <p>
            Når registrerer deg og lager en brukerkonto, kan vi be om din kontaktinformasjon, som
            for eksempel navn, e-postadresse, telefonnummer og adresse.
        </p>

        <h2>Hvordan vi bruker informasjonen din</h2>

        <p>Vi bruker informasjonen vi samler inn på forskjellige måter, som for eksempel til:</p>

        <ul>
            <li>Drift og vedlikehold av nettstedet vårt</li>
            <li>Forbedre, tilpasse og utvikle nettstedet vårt</li>
            <li>Forstå og analysere hvordan du bruker nettstedet vårt</li>
            <li>Utvikle nye produkter, tjenester og funksjoner</li>
            <!-- <li>
        Communicate with you, either directly or through one of our partners,
        including for customer service, to provide you with updates and other
        information relating to the website, and for marketing and promotional
        purposes
      </li>
      <li>Send you emails</li>
      <li>Find and prevent fraud</li> -->
        </ul>
        <br />
        <h2>Loggfiler</h2>

        <p>
            Visuado følger en standard prosedyre for bruk av loggfiler. Disse filene logger
            besøkende når de besøker nettstedet. Alle vertsfirmaer gjør dette og er en del av
            analysen til hostingtjenester. Informasjonen som samles inn av loggfiler inkluderer
            internettprotokoller IP-adresser, nettlesertype, Internett-leverandør (ISP), dato og
            tidstempel, henvisende / avsluttende sider, og muligens antall klikk. Disse er ikke
            koblet til personlig identifiserbar informasjon. Formålet med informasjonen er å
            analysere trender, administrere nettstedet, spore brukernes bevegelse på nettstedet og
            samle demografisk informasjon.
        </p>

        <h2>Informasjonskapsler og Web beacons</h2>

        <p>
            Som alle andre nettsteder bruker Visuado sine informasjonskapsler (cookies). Disse
            informasjonskapslene brukes til å lagre informasjon, som for ekesempel besøkernes
            preferanser og sidene på nettstedet som besøkende logget inn på eller besøkt.
            Informasjonen brukes til å optimalisere brukeropplevelsen ved å tilpasse innholdet på
            websiden vår basert på besøkendes nettlesertype og / eller annen informasjon.
        </p>

        <p>
            For mer generell informasjon om informasjonskapsler kan du besøke vår side om
            <a href="/cookie-policy">cookies</a>.
        </p>

        <h2>Personvernpolitikk for annonseringspartnere</h2>

        <p>
            Du kan konsultere denne listen for å finne personvernreglene for hver av Visuado sine
            annonseringspartnere.
        </p>

        <p>
            Tredjeparts annonsetjenere eller annonsenettverk bruker teknologier som
            informasjonskapsler, JavaScript eller nettlesere som brukes i deres respektive annonser
            og lenker som vises på Visuado , som sendes direkte til brukernes nettlesere. De mottar
            automatisk IP-adressen din når dette skjer. Disse teknologiene brukes til å måle
            effektiviteten til annonseringskampanjene deres og / eller for å tilpasse
            annonseinnholdet du ser på nettsteder du besøker.
        </p>

        <p>
            Merk at Visuado ikke har tilgang til eller kontroll over disse informasjonskapslene som
            brukes av tredjeparts annonsører.
        </p>

        <h2>Personvernpolitikk for tredjeparter</h2>

        <p>
            Visuado 's personvernregler gjelder ikke andre annonsører eller nettsteder. Dermed
            anbefaler vi deg å konsultere de respektive personvernreglene for disse tredjeparts
            annonseservere for mer detaljert informasjon. De kan inneholde praksis og instruksjoner
            for hvordan du velger bort visse alternativer.
        </p>

        <p>
            Du kan velge å deaktivere informasjonskapsler gjennom de individuelle
            nettleseralternativene dine. Hvis du vil vite mer detaljert informasjon om
            informasjonskapselhåndtering med spesifikke nettlesere, kan du finne den på nettlesernes
            respektive nettsteder.
        </p>

        <h2>GDPR-rettigheter til beskyttelse av data</h2>

        <p>
            Vi vil forsikre deg om at du er fullstendig klar over alle dine rettigheter til
            databeskyttelse. Hver bruker har rett til følgende:
        </p>
        <p>
            Retten til tilgang - Du har rett til å be om kopier av dine personopplysninger. Vi kan
            belaste deg for et lite gebyr for denne tjenesten.
        </p>
        <p>
            Retten til retting - Du har rett til å be om at vi korrigerer all informasjon du mener
            er unøyaktig. Du har også rett til å be om at vi fyller ut informasjonen du mener er
            ufullstendig.
        </p>
        <p>
            Retten til å slette - Du har rett til å be om at vi sletter dine personopplysninger,
            under visse betingelser.
        </p>
        <p>
            Retten til å begrense behandlingen - Du har rett til å be om at vi begrenser
            behandlingen av dine personopplysninger, under visse betingelser.
        </p>
        <p>
            Retten til å innvende mot behandling - Du har rett til å innvende mot vår behandling av
            dine personopplysninger, under visse betingelser.
        </p>
        <p>
            Retten til dataportabilitet - Du har rett til å be om at vi overfører dataene som vi har
            samlet inn til en annen organisasjon, eller direkte til deg, under visse betingelser.
        </p>
        <p>
            Hvis du sender en forespørsel, har vi en måned til å svare deg. Hvis du ønsker å utøve
            noen av disse rettighetene, kan du kontakte oss.
        </p>

        <h2>Informasjon om barn</h2>

        <p>
            En annen del av vår prioritering er å legge til beskyttelse for barn mens du bruker
            internett. Vi oppfordrer foreldre og foresatte til å observere, delta i og / eller
            overvåke og veilede deres online aktivitet.
        </p>
        <p>
            Visuado samler ikke bevisst opp noen personlig identifiserbar informasjon fra barn under
            13 år. Hvis du tror at barnet ditt ga denne typen informasjon på nettstedet vårt,
            oppfordrer vi deg til å kontakte oss umiddelbart og vi vil gjøre vårt beste for å gjøre
            det. for å fjerne slik informasjon omgående fra postene våre.
        </p>
    </v-sheet>
</template>
